<div mat-dialog-title>Inventory Alert
    <div class="dialog-close-button">
        <a (click)="onClose()" id="close">
            <img src="/assets/images/close-popup.png">
        </a>
    </div>
</div>
<div mat-dialog-content cdkFocusInitial>
    <div *ngIf="excludedProductIds">
        <p>The item(s) you have requested to be added to your cart is not available:
            {{excludedProductIds}}</p>
    </div>
    <div *ngIf="outOfStockProductIds">
        <p>The item(s) you have requested to be added to your cart is (are) temporarily out of stock. Please review the item's
            Product Detail page for available substitutes:
            {{outOfStockProductIds}}</p>
    </div>
    <div *ngIf="lowQuantityProductIds">
        <p>The available inventory for the following item(s) are lower than the quantity you entered:
            <span [ngStyle]="{'font-weight': this.websiteName==='Major' ? 'bold' : 'normal' }">{{lowQuantityProductIds}}</span></p>
        <p class="info-message" *ngIf="this.websiteName==='Parmed'">The amount available for your order will be noted in red under the available quantity
            column when you view your shopping
            cart.</p>
        <p class="info-message" *ngIf="this.websiteName==='Major'">The amount available for your order will be noted in red under the 'Available Quantity' column when you view your shopping cart. 
            The remaining quantity will be automatically placed on backorder. 
            Your selected payment method will be charged for these item(s) at the time of fulfillment. 
            Shipments for backorder only items are automatic, and may not be edited or cancelled once submitted. 
            Please select 'OK' below to continue.
        </p>
    </div>
    <div *ngIf="invalidSubscriptionIds">
        <p>The item(s) you requested is not currently available:<br/>
        {{invalidSubscriptionIds}}</p>
        <p class="subcribe-alert">
            For questions, contact your Sales Rep or our Customer Service department.
        </p>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true" id="btn-ok">OK</button>
</div>